import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";

import Login from "./pages/Login";
import Logout from "./pages/Logout";
import Play from "./pages/Play";
import MyProfile from "./pages/MyProfile";
import Users from "./pages/Users";
import Library from "./pages/Library";
import Playlists from "./pages/Playlists";
import Locations from "./pages/Locations";
import Screens from "./pages/Screens";
import Error403 from "./pages/Error403";
import Error404 from "./pages/Error404";
import AppLayout from "./layout/AppLayout";
import FrontLayout from "./layout/FrontLayout";
import ProtectedRoute from "./routes/ProtectedRoute";
import "antd/dist/reset.css";
import Cities from "./pages/Cities";
import Brands from "./pages/Brands";
import Inventory from "./pages/Inventory";
import Otp from "./pages/Otp";
import { msalInstance } from "./msalConfig";
import PermissionDenied from "./pages/PermissionDenied";
import Roles from "./pages/Roles";
import Schedules from "./pages/Schedules";
import Sequences from "./pages/Sequences";
import Devices from "./pages/Device";
import DeviceErrors from "./pages/DeviceErrors";
import Dashboard from "./pages/Dashboard";
import Logs from "./pages/Logs";
import AndroidAppVersions from "./pages/AndroidAppVersions";
import MeetingRoomDevices from "./pages/MeetingRoomDevices";
import MeetingRoomApk from "./pages/MeetingRoomApk";
import Campaigns from "./pages/Campaigns";
import TizenAppVersions from "./pages/TizenAppVersions";
import LgAppVersions from "./pages/LgAppVersions";
import WebAppVersions from "./pages/WebAppVersions";

function App() {
  const user = JSON.parse(localStorage.getItem("userData"));
  return (
    <MsalProvider instance={msalInstance}>
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Login />} />
          <Route path="/logout" element={<Logout />} />

          {/* Front Layout Routes */}
          <Route path="/play/:slug" element={<FrontLayout />}>
            <Route index element={<Play />} />
          </Route>
          <Route path="/otp/:slug" element={<FrontLayout />}>
            <Route index element={<Otp />} />
          </Route>
          <Route path="/access-denied" element={<PermissionDenied />} />

          {/* Protected Routes */}
          <Route
            path="/"
            element={
              <ProtectedRoute user={user}>
                <AppLayout />
              </ProtectedRoute>
            }
          >
            <Route path="my-profile" element={<MyProfile />} />
            <Route path="roles" element={<Roles />} />
            <Route path="users" element={<Users />} />
            <Route path="cities" element={<Cities />} />
            <Route path="locations" element={<Locations />} />
            <Route path="brands" element={<Brands />} />
            <Route path="inventory" element={<Inventory />} />
            <Route path="library" element={<Library />} />
            <Route path="playlists" element={<Playlists />} />
            <Route path="screens" element={<Screens />} />
            <Route path="schedules" element={<Schedules />} />
            <Route path="campaigns" element={<Campaigns />} />
            <Route path="sequences/:id" element={<Sequences />} />
            <Route path="signage-tvs" element={<Devices />} />
            <Route path="device-errors" element={<DeviceErrors />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="logs" element={<Logs />} />
            <Route path="android-app-versions" element={<AndroidAppVersions />} />
            <Route path="meeting-room-tablets" element={<MeetingRoomDevices />} />
            <Route path="meeting-room-app" element={<MeetingRoomApk />} />
            <Route path="tizen-app-versions" element={<TizenAppVersions />} />
            <Route path="lg-app-versions" element={<LgAppVersions />} />
            <Route path="web-app-versions" element={<WebAppVersions />} />
          </Route>

          <Route path="/error-403" element={<Error403 />} />
          <Route path="*" element={<Error404 />} />
        </Routes>
      </Router>
    </MsalProvider>
  );
}

export default App;
